import { ENV } from '@constants/environment';

export const getBonsaiUiProductUrl = (productPublicId: string) =>
  `${ENV.bonsaiUIHostedUrl}/?bonsai=product_${productPublicId}`;
